import {gql} from 'apollo-boost';

export const GET_EXAMQUESTIONTYPE = gql`
  query getExamQuestionType($id : ID!){
    getExamQuestionType (
      id: $id
    ) {
      id code nameLocal nameEng
    }
  }
`;

export const GET_EXAMQUESTIONTYPES = gql`
  query getExamQuestionTypes {
    getExamQuestionTypes {
      id code nameLocal nameEng
    }
  }
`;

export const ADD_EXAMQUESTIONTYPE = gql`
  mutation addExamQuestionType(
    $vdoLiveSetId: ID!
    $examQuestionTypeInput: ExamQuestionTypeInput!
  ) {
    addExamQuestionType(
      vdoLiveSetId: $vdoLiveSetId
      examQuestionTypeInput: $examQuestionTypeInput
    ) {
      id code nameLocal nameEng
    }
  }
`;

export const UPDATE_EXAMQUESTIONTYPE = gql`
  mutation updateExamQuestionType(
    $id: ID!,
    $examQuestionTypeInput: ExamQuestionTypeInput!
  ) {
    updateExamQuestionType(
      id: $id
      examQuestionTypeInput: $examQuestionTypeInput
    ) {
      id code nameLocal nameEng
    }
  }
`;

export const DELETE_EXAMQUESTIONTYPE = gql`
  mutation deleteExamQuestionType($id: ID!) {
    deleteExamQuestionType(
      id: $id
    ) {
      id code nameLocal nameEng
    }
  }
`;

